module.exports = __webpack_public_path__ + "img/spotted.65516d6d.jpg";